import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';

import { VehicleOperationalStatusStoreModelEnum } from '@domain/single-site/single-site.enums';

import { appCharging16Icon } from '@icons/charging-16';
import { appCharging40Icon } from '@icons/charging-40';
import { appFaulted16Icon } from '@icons/faulted-16';
import { appFaulted40Icon } from '@icons/faulted-40';
import { appInDepot16Icon } from '@icons/in-depot-16';
import { appInDepot40Icon } from '@icons/in-depot-40';
import { appOnTheRoad16Icon } from '@icons/on-the-road-16';
import { appOnTheRoad40Icon } from '@icons/on-the-road-40';
import { appQueued16Icon } from '@icons/queued-16';
import { appQueued40Icon } from '@icons/queued-40';
import { appReady16Icon } from '@icons/ready-16';
import { appReady40Icon } from '@icons/ready-40';
import { appUnknown16Icon } from '@icons/unknown-16';
import { appUnknown40Icon } from '@icons/unknown-40';

import { VEHICLE_STATUS_PROPERTIES_MAP } from './vehicle-operational-status-icon.view-model';

@Component({
  selector: 'app-vehicle-operational-status-icon',
  imports: [NgClass, SvgIconComponent],
  templateUrl: './vehicle-operational-status-icon.component.html',
  styleUrl: './vehicle-operational-status-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleOperationalStatusIconComponent {
  public status = input.required<VehicleOperationalStatusStoreModelEnum>();
  public iconVariant = input<'16' | '40'>('40');
  public iconSize = input<string>('40');
  public containerClasses = input<string>();

  public readonly STATUS_PROPERTIES_MAP = VEHICLE_STATUS_PROPERTIES_MAP;

  constructor() {
    injectRegisterIcons([
      appReady16Icon,
      appReady40Icon,
      appCharging16Icon,
      appCharging40Icon,
      appQueued16Icon,
      appQueued40Icon,
      appFaulted16Icon,
      appFaulted40Icon,
      appInDepot16Icon,
      appInDepot40Icon,
      appOnTheRoad16Icon,
      appOnTheRoad40Icon,
      appUnknown16Icon,
      appUnknown40Icon,
    ]);
  }
}
